import { SET_BLACK_SYSTEMS } from '../actions';
import { reduxStoreTypes } from '@type/redux-store';

const blackSystems = (blackSystems: string[] = [], action: reduxStoreTypes.BlackSystemsAction) => {
    if (action.type === SET_BLACK_SYSTEMS) {
        return action.blackSystems
    }
    return blackSystems
}
export default blackSystems